export default {
  CLOSE: 'Schließen',
  BTN: {
    DOWNLOAD: 'Rechnung runterladen',
  },
};
